import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { NavComponent } from './layout/nav/nav.component';
import { HomeComponent } from './component/home/home.component';
import { LibraryComponent } from './component/library/library.component';
import { MuseumComponent } from './component/museum/museum.component';
import { HallOfFameComponent } from './component/hall-of-fame/hall-of-fame.component';
import { WriterComponent } from './component/writer/writer.component';
import { OvooComponent } from './component/ovoo/ovoo.component';
import { SearchComponent } from './component/search/search.component';
import { BookComponent } from './component/book/book.component';
import { ScriptComponent } from './component/script/script.component';
import { BashengComponent } from './component/basheng/basheng.component';
import { VideoComponent } from './component/video/video.component';
import { ProfileComponent } from './component/profile/profile.component';
import { AuthorComponent } from './component/author/author.component';

import { NgxGlideModule } from 'ngx-glide';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { PageComponent } from './component/page/page.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HomeComponent,
    LibraryComponent,
    MuseumComponent,
    HallOfFameComponent,
    WriterComponent,
    OvooComponent,
    SearchComponent,
    BookComponent,
    ScriptComponent,
    BashengComponent,
    VideoComponent,
    ProfileComponent,
    AuthorComponent,
    PageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxGlideModule,
    NzImageModule,
    BrowserAnimationsModule,
    NzPaginationModule
    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
